import { render } from "./blogs-comments-table.vue?vue&type=template&id=0323500a"
import script from "./blogs-comments-table.vue?vue&type=script&lang=js"
export * from "./blogs-comments-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__